import * as z from 'zod';
import { Quantity } from '../base-schemas';
import { ReservableProductResource } from './ReservableProduct';
import { ReservableResource } from './Reservable';
// Request schema
export const UpdatePoolModeStockQuantityRequest = z.object({
    stock_quantity: Quantity
});
// Success response schema - reuses existing types instead of duplicating
export const UpdatePoolModeStockQuantitySuccessResponse = z.object({
    status: z.literal('success'),
    data: z.object({
        product: ReservableProductResource,
        reservables: z.array(ReservableResource)
    }),
    snackbar: z.object({ color: z.string(), text: z.string() }).nullable(),
    print: z.unknown().nullable()
});
// Error code constant for individually tracked products
export const PRODUCT_INDIVIDUALLY_TRACKED_ERROR = 'product_individually_tracked';
